import React from 'react';

import AdminLayout from '../../components/AdminLayout';
import TypersTable from '../../components/TypersTable';

const AdminTypersPage = () => (
  <AdminLayout>
    <TypersTable />
  </AdminLayout>
);

export default AdminTypersPage;
